// AGENTS group — the authed CRUD surfaces (design doc's G2). Every route
// here hangs off `authedRoute` (routes/guards.tsx): signed-out hits redirect
// to `/sign-in?redirect_url=...` before the placeholder even mounts. This is
// the group the design doc calls out as "mechanical; parallelizes across
// subagents cleanly" (FRONTEND_SPA_DESIGN.md §6, G2) — hence its own file so
// parallel porters never touch core.tsx or admin.tsx.
//
// OWNERSHIP: this file is the G2 porters' — one subagent per route (or a
// handful grouped) is the expected split. Add new authed routes here, never
// in core.tsx/admin.tsx.
import { authedRoute } from './guards';
import { agentsPageRoute } from './agents-page';
import { appsPageRoute } from './apps-page';
import { appDetailRoute } from './app-detail';
import { connectionsPageRoute } from './connections-page';
import { memoryPageRoute } from './memory-page';
import { libraryRoute } from './library';
import { documentsRoute } from './documents';
import { skillsRoute } from './skills';
import { visualizationsRoute } from './visualizations';
import { canvasRoute } from './canvas';
import { canvasDetailRoute } from './canvas-detail';
import { mediaRoute } from './media';
import { billingRoute } from './billing';
import { labsGenuiRoute } from './labs-genui';
import { labsGenuiDetailRoute } from './labs-genui-detail';

export const agentsRoutes = [
  agentsPageRoute,
  appsPageRoute,
  appDetailRoute,
  billingRoute,
  canvasRoute,
  canvasDetailRoute,

  // PORTED — /connections. apps/web's app/connections/page.tsx had no
  // separate client component to alias-mount (an 867-line async server
  // component with 2 inline server actions), so this was rewritten as a real
  // client component (app/connections/client.tsx) fetching the new
  // apps/server/src/routes/connections.ts endpoints (GET /api/connections,
  // GET/POST /api/connections/browser-logins, POST .../:id/login, GET/DELETE
  // /api/connections/browser-logins/:id, POST /api/connections/authorize).
  // Search/category filters are local state rather than URL search params —
  // see client.tsx's header comment for the full simplifications list.
  connectionsPageRoute,

  documentsRoute,
  libraryRoute,
  mediaRoute,
  memoryPageRoute,
  skillsRoute,
  visualizationsRoute,
  labsGenuiRoute,
  labsGenuiDetailRoute,
];
